
export const packages = [
  "@openimis/fe-core",
  "@openimis/fe-individual",
  "@openimis/fe-social_protection",
  "@openimis/fe-opensearch_reports",
  "@openimis/fe-home",
  "@openimis/fe-location",
  "@openimis/fe-contribution",
  "@openimis/fe-payment",
  "@openimis/fe-admin",
  "@openimis/fe-tools",
  "@openimis/fe-profile",
  "@openimis/fe-calculation",
  "@openimis/fe-policyholder",
  "@openimis/fe-contribution_plan",
  "@openimis/fe-payment_cycle",
  "@openimis/fe-tasks_management",
  "@openimis/fe-invoice",
  "@openimis/fe-language_fr",
  "@openimis/fe-deduplication",
  "@openimis/fe-payroll",
  "@openimis/fe-grievance_social_protection",
  "@openimis/fe-analytics",
  "@openimis/fe-notification",
  "@openimis/fe-activity",
  "@openimis/fe-productive_inclusion",
  "@openimis/fe-merankabandi"
];


export function loadModules(cfg = {}) {
  const loadedModules = [];

  try {
    loadedModules.push(require("@openimis/fe-core").CoreModule(cfg["fe-core"] || {}));
  } catch (error) {
    alert(`Failed to load module "@openimis/fe-core". More details can be found in the developer console. Look for: ${error}`);
    console.error(error);
  }

  try {
    loadedModules.push(require("@openimis/fe-individual").IndividualModule(cfg["fe-individual"] || {}));
  } catch (error) {
    alert(`Failed to load module "@openimis/fe-individual". More details can be found in the developer console. Look for: ${error}`);
    console.error(error);
  }

  try {
    loadedModules.push(require("@openimis/fe-social_protection").SocialProtectionModule(cfg["fe-social_protection"] || {}));
  } catch (error) {
    alert(`Failed to load module "@openimis/fe-social_protection". More details can be found in the developer console. Look for: ${error}`);
    console.error(error);
  }

  try {
    loadedModules.push(require("@openimis/fe-opensearch_reports").OpenSearchReportsModule(cfg["fe-opensearch_reports"] || {}));
  } catch (error) {
    alert(`Failed to load module "@openimis/fe-opensearch_reports". More details can be found in the developer console. Look for: ${error}`);
    console.error(error);
  }

  try {
    loadedModules.push(require("@openimis/fe-home").HomeModule(cfg["fe-home"] || {}));
  } catch (error) {
    alert(`Failed to load module "@openimis/fe-home". More details can be found in the developer console. Look for: ${error}`);
    console.error(error);
  }

  try {
    loadedModules.push(require("@openimis/fe-location").LocationModule(cfg["fe-location"] || {}));
  } catch (error) {
    alert(`Failed to load module "@openimis/fe-location". More details can be found in the developer console. Look for: ${error}`);
    console.error(error);
  }

  try {
    loadedModules.push(require("@openimis/fe-contribution").ContributionModule(cfg["fe-contribution"] || {}));
  } catch (error) {
    alert(`Failed to load module "@openimis/fe-contribution". More details can be found in the developer console. Look for: ${error}`);
    console.error(error);
  }

  try {
    loadedModules.push(require("@openimis/fe-payment").PaymentModule(cfg["fe-payment"] || {}));
  } catch (error) {
    alert(`Failed to load module "@openimis/fe-payment". More details can be found in the developer console. Look for: ${error}`);
    console.error(error);
  }

  try {
    loadedModules.push(require("@openimis/fe-admin").AdminModule(cfg["fe-admin"] || {}));
  } catch (error) {
    alert(`Failed to load module "@openimis/fe-admin". More details can be found in the developer console. Look for: ${error}`);
    console.error(error);
  }

  try {
    loadedModules.push(require("@openimis/fe-tools").ToolsModule(cfg["fe-tools"] || {}));
  } catch (error) {
    alert(`Failed to load module "@openimis/fe-tools". More details can be found in the developer console. Look for: ${error}`);
    console.error(error);
  }

  try {
    loadedModules.push(require("@openimis/fe-profile").ProfileModule(cfg["fe-profile"] || {}));
  } catch (error) {
    alert(`Failed to load module "@openimis/fe-profile". More details can be found in the developer console. Look for: ${error}`);
    console.error(error);
  }

  try {
    loadedModules.push(require("@openimis/fe-calculation").CalculationModule(cfg["fe-calculation"] || {}));
  } catch (error) {
    alert(`Failed to load module "@openimis/fe-calculation". More details can be found in the developer console. Look for: ${error}`);
    console.error(error);
  }

  try {
    loadedModules.push(require("@openimis/fe-policyholder").PolicyHolderModule(cfg["fe-policyholder"] || {}));
  } catch (error) {
    alert(`Failed to load module "@openimis/fe-policyholder". More details can be found in the developer console. Look for: ${error}`);
    console.error(error);
  }

  try {
    loadedModules.push(require("@openimis/fe-contribution_plan").ContributionPlanModule(cfg["fe-contribution_plan"] || {}));
  } catch (error) {
    alert(`Failed to load module "@openimis/fe-contribution_plan". More details can be found in the developer console. Look for: ${error}`);
    console.error(error);
  }

  try {
    loadedModules.push(require("@openimis/fe-payment_cycle").PaymentCycleModule(cfg["fe-payment_cycle"] || {}));
  } catch (error) {
    alert(`Failed to load module "@openimis/fe-payment_cycle". More details can be found in the developer console. Look for: ${error}`);
    console.error(error);
  }

  try {
    loadedModules.push(require("@openimis/fe-tasks_management").TasksManagementModule(cfg["fe-tasks_management"] || {}));
  } catch (error) {
    alert(`Failed to load module "@openimis/fe-tasks_management". More details can be found in the developer console. Look for: ${error}`);
    console.error(error);
  }

  try {
    loadedModules.push(require("@openimis/fe-invoice").InvoiceModule(cfg["fe-invoice"] || {}));
  } catch (error) {
    alert(`Failed to load module "@openimis/fe-invoice". More details can be found in the developer console. Look for: ${error}`);
    console.error(error);
  }

  try {
    loadedModules.push(require("@openimis/fe-language_fr").LanguageFrModule(cfg["fe-language_fr"] || {}));
  } catch (error) {
    alert(`Failed to load module "@openimis/fe-language_fr". More details can be found in the developer console. Look for: ${error}`);
    console.error(error);
  }

  try {
    loadedModules.push(require("@openimis/fe-deduplication").DeduplicationModule(cfg["fe-deduplication"] || {}));
  } catch (error) {
    alert(`Failed to load module "@openimis/fe-deduplication". More details can be found in the developer console. Look for: ${error}`);
    console.error(error);
  }

  try {
    loadedModules.push(require("@openimis/fe-payroll").PayrollModule(cfg["fe-payroll"] || {}));
  } catch (error) {
    alert(`Failed to load module "@openimis/fe-payroll". More details can be found in the developer console. Look for: ${error}`);
    console.error(error);
  }

  try {
    loadedModules.push(require("@openimis/fe-grievance_social_protection").GrievanceSocialProtectionModule(cfg["fe-grievance_social_protection"] || {}));
  } catch (error) {
    alert(`Failed to load module "@openimis/fe-grievance_social_protection". More details can be found in the developer console. Look for: ${error}`);
    console.error(error);
  }

  try {
    loadedModules.push(require("@openimis/fe-analytics").AnalyticsModule(cfg["fe-analytics"] || {}));
  } catch (error) {
    alert(`Failed to load module "@openimis/fe-analytics". More details can be found in the developer console. Look for: ${error}`);
    console.error(error);
  }

  try {
    loadedModules.push(require("@openimis/fe-notification").NotificationModule(cfg["fe-notification"] || {}));
  } catch (error) {
    alert(`Failed to load module "@openimis/fe-notification". More details can be found in the developer console. Look for: ${error}`);
    console.error(error);
  }

  try {
    loadedModules.push(require("@openimis/fe-activity").ActivityModule(cfg["fe-activity"] || {}));
  } catch (error) {
    alert(`Failed to load module "@openimis/fe-activity". More details can be found in the developer console. Look for: ${error}`);
    console.error(error);
  }

  try {
    loadedModules.push(require("@openimis/fe-productive_inclusion").ProductiveInclusionModule(cfg["fe-productive_inclusion"] || {}));
  } catch (error) {
    alert(`Failed to load module "@openimis/fe-productive_inclusion". More details can be found in the developer console. Look for: ${error}`);
    console.error(error);
  }

  try {
    loadedModules.push(require("@openimis/fe-merankabandi").MerankabandiModule(cfg["fe-merankabandi"] || {}));
  } catch (error) {
    alert(`Failed to load module "@openimis/fe-merankabandi". More details can be found in the developer console. Look for: ${error}`);
    console.error(error);
  }

  return loadedModules;
}
